var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabourCultivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
    fill: "#5F7F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H11V5H13V2Z",
    fill: "#5F7F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H11V22H13V19Z",
    fill: "#5F7F04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H19V13H22V11Z",
    fill: "#5F7F04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11H2V13H5V11Z",
    fill: "#5F7F04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3645 4.22123L16.2432 6.34253L17.6574 7.75673L19.7787 5.63543L18.3645 4.22123Z",
    fill: "#5F7F04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34298 16.2433L4.22168 18.3646L5.63588 19.7788L7.75718 17.6575L6.34298 16.2433Z",
    fill: "#5F7F04"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6574 16.2429L16.2432 17.6571L18.3645 19.7784L19.7787 18.3642L17.6574 16.2429Z",
    fill: "#5F7F04"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6349 4.22154L4.2207 5.63574L6.342 7.75704L7.7562 6.34284L5.6349 4.22154Z",
    fill: "#5F7F04"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69H66V75H73V69Z",
    fill: "#5F7F04"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69H83V75H90V69Z",
    fill: "#5F7F04"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77H67V86H72V77Z",
    fill: "#5F7F04"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77H84V86H89V77Z",
    fill: "#5F7F04"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88H62V94H74V88Z",
    fill: "#5F7F04"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94 88H82V94H94V88Z",
    fill: "#5F7F04"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43H56V52H60V43Z",
    fill: "#5F7F04"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22L44.004 27.73H44V33.35C44.627 33.127 45.298 33 46 33C46.702 33 47.373 33.128 48 33.35V27.73H47.996L57 22L56 16L51 18L52 21L47 23H45L40 21L41 18L36 16L35 22Z",
    fill: "#5F7F04"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19V10.931C50.945 10.438 54 7.079 54 3C49.921 3 46.562 6.055 46.069 10H45.931C45.438 6.055 42.079 3 38 3C38 7.079 41.055 10.438 45 10.931V19H47Z",
    fill: "#5F7F04"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9 83.931V90H6L3 94H57L54 90H51V83.931C54.945 83.438 58 80.079 58 76C53.921 76 50.562 79.055 50.069 83H49.931C49.438 79.055 46.079 76 42 76C42 80.079 45.055 83.438 49 83.931V90H31V83.931C34.945 83.438 38 80.079 38 76C33.921 76 30.562 79.055 30.069 83H29.931C29.438 79.055 26.079 76 22 76C22 80.079 25.055 83.438 29 83.931V90H11V83.931C14.945 83.438 18 80.079 18 76C13.921 76 10.562 79.055 10.069 83H9.931C9.438 79.055 6.079 76 2 76C2 80.079 5.055 83.438 9 83.931Z",
    fill: "#5F7F04"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24V37H89V24H79V19.816C80.163 19.403 81 18.304 81 17C81 15.343 79.657 14 78 14C76.343 14 75 15.343 75 17C75 18.304 75.837 19.403 77 19.816V24H67ZM70 27H74V29H70V27ZM82 27H86V29H82V27ZM82 34H74V32H82V34Z",
    fill: "#5F7F04"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67H94V39H62V67ZM69 44H87V62H69V44Z",
    fill: "#5F7F04"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59C81.3137 59 84 56.3137 84 53C84 49.6863 81.3137 47 78 47C74.6863 47 72 49.6863 72 53C72 56.3137 74.6863 59 78 59Z",
    fill: "#5F7F04"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43C48.2091 43 50 41.2091 50 39C50 36.7909 48.2091 35 46 35C43.7909 35 42 36.7909 42 39C42 41.2091 43.7909 43 46 43Z",
    fill: "#5F7F04"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 44.9999L51.1172 42.1169C50.3572 43.3599 49.1622 44.3089 47.7402 44.7399L54.0002 50.9999V44.9999Z",
    fill: "#5F7F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabourCultivation);
export default __webpack_public_path__ + "static/media/labour-cultivation.ddb1a8ba9007a38ceedd8f6ac1c60702.svg";
export { ForwardRef as ReactComponent };